import { ProfileMenuOptions, ProfilePageRoute } from '@lentau/layout/mobile-menu/shared/enums';
import { ProfileNamesB2B, ProfileNamesB2C } from '@lentau/layout/mobile-menu/shared/constants';
import { RetailBrands } from '@lentau/ui-kit/core/tokens/constants';
import { SemUsePatternRequest } from 'angular-api-gateway/v1/model/semUsePatternRequest';

export const { PatternTypeEnum } = SemUsePatternRequest;

export const NOT_FOUND_PAGE = 'err_not_found';

export const PageDescriptionsByBrands: Map<RetailBrands | string, { [key: string]: string }> = new Map([
  [
    RetailBrands.UTKONOS,
    {
      // eslint-disable-next-line max-len
      '/cat': `Онлайн-магазин Утконос - купить в интернет-магазине Утконос с быстрой доставкой на дом в день заказа. Акции, скидки, отзывы и низкие цены в каталоге онлайн-магазина.`,
      // eslint-disable-next-line max-len
      '/item': `Онлайн-магазин Утконос - купить недорого в интернет-магазине Утконос. Доставка на дом в день заказа. Цены и отзывы, акции и скидки в каталоге онлайн-магазина.`,
    },
  ],
  [
    RetailBrands.LENTA_ONLINE,
    {
      // eslint-disable-next-line max-len
      '/cat': `Лента Онлайн - купить с доставкой на дом, в офис и на дачу. Низкие цены, акции и скидки. В каталоге интернет-магазина Лента Онлайн широкий ассортимент товаров и быстрая доставка.`,
      // eslint-disable-next-line max-len
      '/item': `Лента Онлайн - купить с доставкой на дом, дачу и офис. Широкий ассортимент, быстрая доставка, скидки, акции и выгодные предложения в интернет-магазине Лента Онлайн.`,
    },
  ],
  [
    RetailBrands.DOM,
    {
      // eslint-disable-next-line max-len
      '/cat': `Дом Лента - купить с доставкой на дом, в офис и на дачу. Низкие цены, акции и скидки. В каталоге интернет-магазина Дом Лента широкий ассортимент товаров и быстрая доставка.`,
      // eslint-disable-next-line max-len
      '/item': `Дом Лента - купить с доставкой на дом, дачу и офис. Широкий ассортимент, быстрая доставка, скидки, акции и выгодные предложения в интернет-магазине Дом Лента.`,
    },
  ],
  [
    RetailBrands.MONETKA,
    {
      // eslint-disable-next-line max-len
      '/cat': `Монетка - купить с доставкой на дом, в офис и на дачу. Низкие цены, акции и скидки. В каталоге интернет-магазина Монетка широкий ассортимент товаров и быстрая доставка.`,
      // eslint-disable-next-line max-len
      '/item': `Монетка - купить с доставкой на дом, дачу и офис. Широкий ассортимент, быстрая доставка, скидки, акции и выгодные предложения в интернет-магазине Монетка.`,
    },
  ],
  [
    RetailBrands.SUPERJAM,
    {
      // eslint-disable-next-line max-len
      '/cat': `Джем - купить с доставкой на дом или забрать самовывозом. Низкие цены, акции и скидки. В каталоге интернет-магазина Джем широкий ассортимент товаров и быстрая доставка.`,
      // eslint-disable-next-line max-len
      '/item': `Джем - купить с доставкой на дом или самовывозом. Широкий ассортимент, быстрая доставка, скидки, акции и выгодные предложения в интернет-магазине Джем.`,
    },
  ],
]);

export const DefaultPageDescriptionsByBrands: Map<RetailBrands | string, string> = new Map([
  [
    RetailBrands.UTKONOS,
    // eslint-disable-next-line max-len
    `Онлайн-магазин Утконос - заказать продукты с доставкой на дом или в офис. Специальные предложения, акции и скидки на широкий ассортимент товаров и продуктов питания в нашем интернет-магазине.`,
  ],
  [
    RetailBrands.LENTA_ONLINE,
    // eslint-disable-next-line max-len
    `Лента Онлайн - доставка продуктов питания и других товаров на дом, в офис и на дачу. Выгодные предложения, низкие цены, скидки и акции - все для удобного заказа в нашем интернет-магазине.`,
  ],
  [
    RetailBrands.DOM,
    // eslint-disable-next-line max-len
    `Дом Лента - доставка строительных материалов и других товаров на дом, в офис и на дачу. Выгодные предложения, низкие цены, скидки и акции - все для удобного заказа в нашем интернет-магазине.`,
  ],
  [
    RetailBrands.SUPERJAM,
    // eslint-disable-next-line max-len
    `Джем - доставка продуктов и других товаров на дом и самовывоз из магазина. Выгодные предложения, низкие цены, скидки и акции - все для удобного заказа в нашем интернет-магазине.`,
  ],
]);

export const ProfileTitlesByUrlB2C: Map<string, string> = new Map<string, string>([
  [ProfilePageRoute.MY_ACCOUNT, ProfileNamesB2C.get(ProfileMenuOptions.MY_ACCOUNT)],
  [ProfilePageRoute.UPDATE_PROFILE, ProfileNamesB2C.get(ProfileMenuOptions.UPDATE_PROFILE)],
  [ProfilePageRoute.ORDERS, ProfileNamesB2C.get(ProfileMenuOptions.ORDER)],
  [ProfilePageRoute.ORDER, ProfileNamesB2C.get(ProfileMenuOptions.ORDER)],
  [ProfilePageRoute.ORDER_FEEDBACK, ProfileNamesB2C.get(ProfileMenuOptions.ORDER_FEEDBACK)],
  [ProfilePageRoute.LAST, ProfileNamesB2C.get(ProfileMenuOptions.LAST)],
  [ProfilePageRoute.PAYMENT_OPTIONS, ProfileNamesB2C.get(ProfileMenuOptions.PAYMENT_OPTIONS)],
  [ProfilePageRoute.FAVORITES, ProfileNamesB2C.get(ProfileMenuOptions.FAVORITES)],
  [ProfilePageRoute.LOYALTY, ProfileNamesB2C.get(ProfileMenuOptions.LOYALTY)],
  [ProfilePageRoute.NOTIFICATION, ProfileNamesB2C.get(ProfileMenuOptions.NOTIFICATION)],
  [ProfilePageRoute.ABOUT_SERVICE, ProfileNamesB2C.get(ProfileMenuOptions.ABOUT_SERVICE)],
  [ProfilePageRoute.STAMPS, ProfileNamesB2C.get(ProfileMenuOptions.STAMPS)],
  [ProfilePageRoute.COUPONS, ProfileNamesB2C.get(ProfileMenuOptions.COUPONS)],
  [ProfilePageRoute.LOYALTY_BALANCE, ProfileNamesB2C.get(ProfileMenuOptions.LOYALTY_BALANCE)],
]);

export const ProfileTitlesByUrlB2B: Map<string, string> = new Map<string, string>([
  [ProfilePageRoute.MY_ACCOUNT, ProfileNamesB2B.get(ProfileMenuOptions.MY_ACCOUNT)],
  [ProfilePageRoute.UPDATE_PROFILE, ProfileNamesB2B.get(ProfileMenuOptions.UPDATE_PROFILE)],
  [ProfilePageRoute.ORDERS, ProfileNamesB2B.get(ProfileMenuOptions.ORDER)],
  [ProfilePageRoute.ORDER, ProfileNamesB2B.get(ProfileMenuOptions.ORDER)],
  [ProfilePageRoute.ORDER_FEEDBACK, ProfileNamesB2B.get(ProfileMenuOptions.ORDER_FEEDBACK)],
  [ProfilePageRoute.LAST, ProfileNamesB2B.get(ProfileMenuOptions.LAST)],
  [ProfilePageRoute.PAYMENT_OPTIONS, ProfileNamesB2B.get(ProfileMenuOptions.PAYMENT_OPTIONS)],
  [ProfilePageRoute.FAVORITES, ProfileNamesB2B.get(ProfileMenuOptions.FAVORITES)],
  [ProfilePageRoute.LOYALTY, ProfileNamesB2B.get(ProfileMenuOptions.LOYALTY)],
]);

export enum MetaTagNames {
  DESCRIPTION = 'description',
  KEYWORDS = 'keywords',
}

export const DefaultTitle: Map<RetailBrands, string> = new Map<RetailBrands, string>([
  [RetailBrands.LENTA_ONLINE, 'Лента – сеть магазинов с доставкой товаров на дом'],
  [RetailBrands.SUPERJAM, 'Джем – доставка и самовывоз продуктов'],
  [
    RetailBrands.UTKONOS,
    'Доставка продуктов на дом в Москве и области  —  заказ еды онлайн в интернет-магазине Утконос',
  ],
]);
